import React from "react";
import SubLayout from "../SubLayout/SubLayout";
import {
    IconClock,
    IconSunrise,
    IconSunset,
    IconCalendar,
    IconSliders,
    IconWhatsApp,
} from "../icons/Icons";

const WHATSAPP_URL = "https://wa.me/640997403";

const items = [
    {
        Icon: IconSunrise,
        title: "Antes de abrir",
        desc: "Te atendemos antes del inicio de la jornada.",
    },
    {
        Icon: IconSunset,
        title: "Después de cerrar",
        desc: "Disponibles al finalizar nuestro horario habitual.",
    },
    {
        Icon: IconCalendar,
        title: "Domingos y festivos",
        desc: "(bajo disponibilidad) Consúltanos sin compromiso.",
    },
    {
        Icon: IconSliders,
        title: "Horarios personalizados",
        desc: "Nos adaptamos a ti.",
    },
];

function CitasEspeciales() {
    return (
        <SubLayout
            icon={IconClock}
            title="Citas fuera de horario"
            intro="¿No puedes venir dentro del horario habitual? Ofrecemos citas especiales fuera del horario de apertura para adaptarnos a tus necesidades."
            centered
        >
            <div className="info-list">
                {items.map(({ Icon, title, desc }) => (
                    <div className="info-item" key={title}>
                        <span className="info-ico">
                            <Icon />
                        </span>
                        <div>
                            <h3>{title}</h3>
                            <p>{desc}</p>
                        </div>
                    </div>
                ))}
            </div>

            <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="wa-cta"
            >
                <IconWhatsApp />
                Consultar disponibilidad y precio por WhatsApp
            </a>
        </SubLayout>
    );
}

export default CitasEspeciales;
